const common = {}

// 交易方式
common.areaList = [
    {
        label: '昆明市',
        value: '1',
    },
    {
        label: '东川区',
        value: '2',
    },
    {
        label: '安宁市',
        value: '3',
    },
    {
        label: '晋宁县',
        value: '4',
    },
    {
        label: '富民县',
        value: '5',
    },
    {
        label: '禄劝县',
        value: '6',
    },
    {
        label: '宜良县',
        value: '7',
    },
    {
        label: '石林县',
        value: '8',
    },
    {
        label: '嵩明县',
        value: '9',
    },
    {
        label: '寻甸县',
        value: '10',
    },
    {
        label: '滇中新区',
        value: '21',
    },
    {
        label: '空港经济区',
        value: '22',
    },
    // {
    //     label: '其他',
    //     value: '',
    // },
    // 昆明市包含
    // 五华区 = 11,
    // 官渡区 = 12,
    // 盘龙区 = 13
    // 西山区 = 14,
    // 呈贡区 = 15,
    // 高新区 = 16,
    // 经开区 = 17,
    // 度假区 = 18,
    // 阳宗海 = 19,
]

// 招标类别(专业)
common.ZhuanYe = {
    1: '施工',
    2: '监理',
    3: '勘察',
    4: '设计',
    5: '货物',
    6: '服务',
    7: '其他',
    8: '设计施工总承包',
    9: 'BT',
    10: 'BOT',
    11: '工程',
    12: '货物采购',
    13: '服务采购',
    14: '综合其他',
    15: '房屋出租',
    16: '产权其他',
}
// 招标类别(专业)
common.ZhuanYe1 = [
    { label: '施工', value: 1 },
    { label: '监理', value: 2 },
    { label: '勘察', value: 3 },
    { label: '设计', value: 4 },
    { label: '货物', value: 5 },
    { label: '服务', value: 6 },
    { label: '其他', value: 7 },
    { label: '设计施工总承包', value: 8 },
    { label: 'BT', value: 9 },
    { label: 'BOT', value: 10 },
    { label: '工程', value: 11 },
    { label: '货物采购', value: 12 },
    { label: '服务采购', value: 13 },
    { label: '综合其他', value: 14 },
    { label: '房屋出租', value: 15 },
    { label: '产权其他', value: 16 },
]

// 招标方式
common.ZhangBiao_FangShi = {
    1: '公开招标',
    2: '邀请招标',
    3: '竞争性谈判',
    4: '单一来源采购',
    5: '询价采购',
    6: '公开竞争性比选',
    7: '竞争性磋商',
    8: '',
    9: '',
}

// 采购项目分包--新增--资金来源
common.ziJin_LaiYuan = {
    1: '全部财政',
    2: '全部自筹',
    3: '财政自筹混合',
    4: '其他',
}

// 项目类型  采购类别
common.projectType = {
    1: '工程',
    2: '货物',
    3: '服务',
}

// 采购项目分包--新增--采购方式
common.zbFangShi = {
    1: '公开招标',
    2: '邀请招标',
    4: '单一来源',
    6: '竞争性谈判',
    7: '竞争性磋商',
    8: '询价采购',
}

// 采购项目分包--新增--组织形式
common.zbZuZhiXingShi = {
    1: '自行组织采购',
    2: '委托采购代理机构采购',
}

// 采购项目分包--新增--政府采购类型
common.zfcgLeiXingFb = {
    JZCGXM: '集中采购项目',
    WTDLXM: '委托代理项目',
    QZXCGXM: '前置性采购项目',
}

// 采购项目分包--新增--资审方式
common.zsFangShi = {
    1: '投标报名',
    2: '资格预审',
    3: '资格后审',
}

// 审核方式
common.shenHeStatus = {
    1001: '未提交',
    1002: '已提交',
    1003: '预受处理中',
    1004: '预受理通过',
    1005: '预受理不通过',
    1006: '受理中',
    1007: '受理通过',
    1008: '受理不通过',
    1009: '备案中',
    1010: '备案通过',
    1011: '备案不通过',
    1012: '已确认',
}

// 公告资源交易行业分类
common.publicResourceState = {
    DL: '电力工程',
    FWJZ: '房屋建筑工程',
    GKHD: '港口与航道工程',
    GL: '公路工程',
    HGSY: '化工石油工程',
    HKHT: '航天航空工程',
    JDAZ: '机电安装工程',
    KS: '矿山工程',
    NL: '农林工程',
    QT: '其他',
    SLSD: '水利水电工程',
    SZ: '市政工程',
    TDZL: '土地整理工程',
    TL: '铁路工程',
    TX: '通信工程',
    YL: '冶炼工程',
}

// 工程专业类型
common.engineeringState = {
    GCSGZCB: '设计施工总承包',
    JL: '监理',
    KC: '勘察',
    QT: '其他',
    SB: '设备采购',
    SG: '施工',
    SJ: '设计',
}

// 公告文件招标方式
common.biddingState = {
    1: '公开招标',
    2: '邀请招标',
    3: '直接发包',
    4: '单一来源',
    5: '预选子工程',
}

common.noticeType = {
    1: '正常',
    2: '变更',
    3: '其他',
}

// 考核结论
common.assessList = {
    0: '完全合格',
    1: '合格',
    2: '基本合格',
    3: '不合格',
}

// 考核评优
common.excellentEvaluateList = {
    0: '国优',
    1: '省优',
    2: '市优',
}

// 考核评级
common.gradeEvaluateList = {
    0: '国家级',
    1: '省级',
    2: '市级',
}

// 骨干企业评优
common.backboneEvaluateList = {
    0: '省级优秀骨干企业',
    1: '省级骨干企业',
}

// 发包监理阶段
common.faBaoJLJieDuan = {
    faBaoJLJieDuanKanCha: '勘察阶段',
    faBaoJLJieDuanSheJi: '设计阶段',
    faBaoJLJieDuanSheBei: '设备监造',
    faBaoJLJieDuanShiGong: '施工阶段',
    faBaoJLJieDuanBaoXiu: '保修阶段',
    faBaoJLJieDuanQiTa: '其他',
}

common.jlFaBaoZhuangTai = {
    1: '未进行',
    2: '正在进行',
    3: '已进行',
}

export default common
